import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { getUserGuides, sortByDate, sortByName } from '../../../actions/supportActions';
import UserGuidesTable from './UserGuidesTable';

class UserGuides extends Component {
  state = {
    data: [],
    activeTabIndex: 0,
    sortColumnName: 'Uploaded',
    sortDirection: 'desc',
  };

  componentDidMount() {
    this.mounted = true;
    const { category } = this.props;
    getUserGuides(category)
      .then(response => {
        if (this.mounted) {
          if (response) {
            this.setState({ data: response });
          } else {
            this.setState({ data: [] });
          }
        }
      });
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  onSort = sortColumnName => {
    const { sortDirection } = this.state;
    this.setState({ sortColumnName, sortDirection: sortDirection === 'desc' ? 'asc' : 'desc' }, () => {
      this.handleSort(sortColumnName, this.state.sortDirection);
    });
  }

  getScrollbarWidth = () => {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);
    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);
    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
  }

  handleTabChange = index => {
    this.setState({ activeTabIndex: index, sortColumnName: 'Uploaded', sortDirection: 'desc' }, () => {
      this.handleSort(this.state.sortColumnName, this.state.sortDirection);
      this.checkForScroll();
    });
  }

  checkForScroll = () => {
    setTimeout(() => {
      const hasScroll = $('.custom-mri-table--body').get(0).scrollHeight > $('.custom-mri-table--body').height();
      if (hasScroll) {
        const scrollWidth = this.getScrollbarWidth();
        $('.custom-mri-table').addClass('has-scroll');
        $('.custom-mri-table .custom-mri-table--head').attr('style', `padding-right: ${scrollWidth}px`);
      } else {
        $('.custom-mri-table').removeClass('has-scroll');
        $('.custom-mri-table .custom-mri-table--head').removeAttr('style');
      }
    }, 500);
  }

  handleSort = (sortColumnName, sortDirection) => {
    const { activeTabIndex } = this.state;
    const data = [...this.state.data];
    if (sortColumnName === 'Uploaded') {
      data[activeTabIndex] = sortByDate(data[activeTabIndex], sortDirection);
    } else if (sortColumnName === 'Name') {
      data[activeTabIndex] = sortByName(data[activeTabIndex], sortDirection);
    }
    this.setState({ data });
  };

  renderTabs = () => {
    const { data, activeTabIndex, sortColumnName, sortDirection } = this.state;
    let tabData = '';
    const tabItems = data.map((item, index) => {
      if (activeTabIndex === index) {
        if (item.files.length > 0) {
          tabData = (
            <UserGuidesTable
              onSort={this.onSort}
              sortColumnName={sortColumnName}
              sortDirection={sortDirection}
              data={item}
              checkForScroll={this.checkForScroll}
            />
          );
        } else {
          tabData = (
            <div>No user guides foud.</div>
          );
        }
      }
      return (
        <li key={index} className={`custom-tab--nav-item ${activeTabIndex === index ? 'custom-tab--nav-active' : ' '}`}>
          <button onClick={() => this.handleTabChange(index)} className="custom-tab--nav-link">
            {item.title.name}
          </button>
        </li>
      );
    });

    return (
      <div className="custom-tab">
        <div className="custom-tab--navigation">
          <ul className="custom-tab--nav">
            {tabItems}
          </ul>
        </div>
        <div className="custom-tab--body custom-tab-block">
          <div className="support-user-guide-table">
            {tabData}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { data } = this.state;
    if (_.isEmpty(data)) {
      return (
        <div className="resources-main-container">
          <div className="custom-tab">
            loading....
          </div>
        </div>
      );
    }
    return (
      <div className="resources-main-container">
        {this.renderTabs()}
      </div>
    );
  }
}


UserGuides.propTypes = {
  category: PropTypes.instanceOf(Object),
};

export default UserGuides;
